import React, { FC } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import cn from 'classnames';
import { FiArrowLeft } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useUserTheme } from 'domains/user/model/selectors';
import css from './styles.module.scss';
import { TGoBack } from '../../types/general';

type Props = RouteComponentProps & {
  back?: TGoBack;
  /** разрешает переход по ссылке */
  disabled?: boolean;
  /* Разрешить расширяться в зависимости от настроек экрана */
  extendable?: boolean;
};

const NavigationHeader: FC<Props> = ({
  history,
  back = null,
  children,
  disabled = true,
  extendable = true,
}) => {
  const { t } = useTranslation();
  const { isThemeExtended, isThemeFull } = useUserTheme();

  return (
    <div
      className={cn(css.navigation, 'NavigationHeader__component', {
        _isBack: !!back,
      })}
    >
      <div
        className={cn('container', {
          resized: extendable,
          extend: isThemeExtended && extendable,
          full: isThemeFull && extendable,
        })}
      >
        <div className={css.navigation__back}>
          {back && (
            <button
              type="button"
              onClick={() => {
                if (disabled) {
                  if (!back.back) {
                    history.push(back.to);
                  } else {
                    history.goBack();
                  }
                }
              }}
              className={css.navigation__back_btn}
            >
              <FiArrowLeft size={20} color="#fff" />
              <span>
                {back.title ||
                  t('campaigns_page.campaign_settings.black_menu.Back')}
              </span>
            </button>
          )}
        </div>
        <div className={css.navigation__tabs}>{children}</div>
      </div>
    </div>
  );
};
export default withRouter(NavigationHeader);
